import { render, staticRenderFns } from "./emerData-2.vue?vue&type=template&id=1201933a&scoped=true&"
import script from "./emerData-2.vue?vue&type=script&lang=js&"
export * from "./emerData-2.vue?vue&type=script&lang=js&"
import style0 from "./emerData-2.vue?vue&type=style&index=0&lang=css&"
import style1 from "./emerData-2.vue?vue&type=style&index=1&id=1201933a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1201933a",
  null
  
)

export default component.exports